import docCookies from 'doc-cookies';

$(function(){
    let one_month_in_seconds = 2629743;
    let searchParams = new URLSearchParams(window.location.search)

    if (searchParams.has('gclid')) {
        docCookies.setItem('google_adwords_referer', 1, one_month_in_seconds, '/');
    }

    if (document.referrer && document.referrer.indexOf('google') > -1) {
        docCookies.setItem('google_referer', 1, one_month_in_seconds, '/');
    }
});



// WEBPACK FOOTER //
// ./static/js/modules/google-referer.js